import React from 'react';
import { IconCheckmark } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './Toggle.styles';

export interface ToggleProps {
  active: boolean;
  disabled?: boolean;
  label: string;
  name: string;
  onToggle: (currentActive: boolean) => void;
  secondaryLabelText?: string;
  value: string;
}

export const Toggle = ({
  active,
  disabled,
  label,
  name,
  onToggle,
  secondaryLabelText,
  value,
}: ToggleProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onToggle(event.target.checked);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (disabled) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle(!active);
    }
  };

  return (
    <div css={[styles.toggleItem, disabled && styles.disabled]}>
      <label
        aria-disabled={disabled}
        aria-pressed={active}
        css={styles.toggleContainer}
        onKeyDown={handleKeyDown}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role="button"
        tabIndex={disabled ? -1 : 0}
      >
        <input
          checked={active}
          css={styles.hiddenInput}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          type="checkbox"
          value={value}
        />

        {/* Visual toggle switch */}
        <div css={styles.toggleSwitch}>
          <span css={styles.toggleSlider}>
            {active && <IconCheckmark color="var(--neutral-black-base)" height={16} width={16} />}
          </span>
        </div>

        <h4 css={styles.toggleLabel}>{label}</h4>
      </label>

      {secondaryLabelText && <span css={styles.secondaryLabel}>{secondaryLabelText}</span>}
    </div>
  );
};
